import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "assets/icons/XIcon.svg";

const CustomDialog = ({ open, onClose, content, title }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "500px",
          padding: "1rem",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.9)",
          backgroundColor: "white",
          borderRadius: "14px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap="0.5rem"
        >
          <Typography variant="h6" fontWeight="600">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <img src={CloseIcon} alt="Close" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {content.map((item, index) => (
          <Box key={index} display="flex" mb={1}>
            <Typography variant="body1">{item.label} :</Typography>
            <Typography variant="body1" fontWeight="600">
              {item.value}
            </Typography>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
